import React from 'react'
import { FormError } from 'react-pagebuilder/pb-components/atoms'

const FormInput = ({
  type = 'text',
  placeholder = '',
  name = '',
  value = '',
  className = '',
  readOnly = false,
  disabled = false,
  status = '',
  errorMessage = '',
  onBlur = () => {},
  onFocus = () => {},
  onChange = () => {},
}) => {
  const classNames = `
    pb-form-input 
    ${status ? ` pb-form-input--${status}` : ''}
    ${className ? ` ${className}` : ''}`

  return (
    <div className={classNames}>
      <input
        type={type}
        name={name}
        value={value}
        className="pb-form-input__input"
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
      />
      <FormError
        className="pb-form-input__error"
        message={errorMessage}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormInput
